namespace OnlineDPR.Application.Shared

open System

type Page =
| Blank
| UserSync
| Report
| RawDataInput
| UpdateTranslations
| ControlPanel
| ControlPanelBwa
| ControlPanelDpr
| BwaOverview
| ClubList
| Invoices
| DprAdministration

[<RequireQualifiedAccess>]
type Template =
| Default
| Empty

type MonthDate = {
    Year: int
    Month: int
}

type DayDate = {
    Year: int
    Month: int
    Day: int
}

module Formats =
    let DateFormat = "yyyy-MM-dd"

module CustomErrorCodes =

    [<Literal>]
    let BwaInputError = 99001
    [<Literal>]
    let DprInputError = 99002

module DateHandling =
    let DayDateOptionToJsString (dayDate:DayDate option)  =
        match dayDate with
        | Some date -> sprintf "%04i-%02i-%02i" date.Year date.Month date.Day
        | None -> ""

    let DayDateToJsString day  =
        sprintf "%04i-%02i-%02i" day.Year day.Month day.Day

    let DayDateToGermanDate day =
        sprintf "%02i.%02i.%04i" day.Day day.Month day.Year

    let MonthDateToJsString (monthDate:MonthDate) =
        sprintf "%04i-%02i" monthDate.Year monthDate.Month

    let DayDateFromDateTime (datetime:DateTime) =
        { Year = datetime.Year; Month = datetime.Month; Day = datetime.Day}



